import { render } from "./my-gradient-swiper.vue?vue&type=template&id=1def0f68"
import script from "./my-gradient-swiper.vue?vue&type=script&lang=js"
export * from "./my-gradient-swiper.vue?vue&type=script&lang=js"

import "./my-gradient-swiper.vue?vue&type=style&index=0&id=1def0f68&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__